module.exports = __webpack_public_path__ + "img/beer_id-82.dbe2dcdf.png";